var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _setup.wrapperClasses
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_vm.prependText || _setup.slots?.prepend ? _c('div', {
    staticClass: "bg-light border-right rounded-left px-3 d-flex align-items-center form-control-prepend"
  }, [_vm._t("prepend", function () {
    return [_vm._v(_vm._s(_vm.prependText))];
  })], 2) : _vm._e(), _vm._t("default"), _setup.slots?.append ? _c('div', {
    staticClass: "bg-light border-left rounded-right px-3 d-flex align-items-center form-control-append"
  }, [_vm._t("append")], 2) : _vm._e()], 2), _c('ProgressBar', {
    attrs: {
      "active": !!_vm.loading
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };